import { api } from './Api'

class ImprezyService {
  getList(sezon) {
    return api.get(`imprezy/getList.php${(sezon ? `?sezon=${sezon}` : '')}`);
  }
  getKalendarzPdfUrl(sezon) {
    return api.get(`imprezy/getKalendarz.php${(sezon ? `?sezon=${sezon}` : '')}`);
  }
  getDetails(id) {
    return api.get(`imprezy/getDetails.php?id=${id}`);
  }
  saveImpreza(impreza) {
    const payload = {
      ...impreza,
      LinksJson: JSON.stringify(impreza?.Links ?? [])
    };
    delete payload.Links;
    return api.post('imprezy/saveImpreza.php', payload);
  }
}

export const imprezyService = new ImprezyService();
